import React from 'react'

const ChevronRight = ({ width = 24, height = 24, color = 'currentColor' }, props) => (
  <svg fill="none" width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" stroke={color} />
  </svg>
)

export default ChevronRight
